import { buildMemoryStorage } from 'axios-cache-interceptor';

export const AxiosCacheGetConfigs = {
    ttl: process.env['NX_PUBLIC_DD_API_CACHE'] || 1000 * 60 * 10, // Milliseconds.
    interpretHeader: true, // Overwrite the cache details from response header in case.
    cacheTakeover: true, // Takeover of cache control based on response headers.
    methods: ['get'], // Cache HTTP methods.
    override: false, // Override the cache always and create new request every time.
};

export const AxiosCacheGlobalConfigs = {
    storage: buildMemoryStorage(false),
    cache: AxiosCacheGetConfigs,
};
